import { LoaderFunctionArgs, redirect, useLoaderData } from 'react-router';
import { urlCourtList, urlCourtReservations } from '@/urls';
import { useNavigate } from 'react-router';
import { DateFormat, formatDate } from '@/data/format/format-date';
import { isValidDate } from '@repo/ui/lib/format/format-date';
import { CourtTimeline } from '@/components/courts/court-timeline';

const CourtReservations = () => {
  const navigate = useNavigate();
  const { date, id, courtId } = useLoaderData<typeof loader>();

  const handleDateChange = (newDate: Date) => {
    navigate(urlCourtReservations(id, courtId, formatDate(newDate, DateFormat.YYYY_MM_DD)));
  };

  return (
    <CourtTimeline
      clubId={id}
      courtId={courtId}
      initialDate={date}
      onDateChange={handleDateChange}
    />
  );
};

const loader = async ({ params }: LoaderFunctionArgs) => {
  const { id = '', courtId = '', date } = params;
  if (!date) {
    return redirect(
      urlCourtReservations(id, courtId, formatDate(new Date(), DateFormat.YYYY_MM_DD))
    );
  }
  const currentDate = new Date(date + 'T00:00:00');
  const isValid = isValidDate(currentDate);
  if (!isValid) {
    return redirect(
      urlCourtReservations(id, courtId, formatDate(new Date(), DateFormat.YYYY_MM_DD))
    );
  }
  return {
    id,
    courtId,
    date: currentDate,
  };
};

export const route = {
  loader,
  path: urlCourtReservations(':id', ':courtId', ':date?'),
  element: <CourtReservations />,
  handle: {
    backLink: (params: { id: string; courtId: string }) => urlCourtList(params.id),
  },
};
